import { render, staticRenderFns } from "./KitchenPreview.vue?vue&type=template&id=3bfbaf76&scoped=true&"
import script from "./KitchenPreview.vue?vue&type=script&lang=js&"
export * from "./KitchenPreview.vue?vue&type=script&lang=js&"
import style0 from "./KitchenPreview.vue?vue&type=style&index=0&id=3bfbaf76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfbaf76",
  null
  
)

export default component.exports